/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 接口域名地址
 * baseImgPath: 图片上传存放地址
 *
 */
//
// let baseUrl = 'https://prego.mintstech.cn'; //预生产
// let baseUrl = 'https://t.mintstech.art'; //测试
// let japibaseUrl = 'https://japi.mintstech.art'; //测试japibaseUrl

let baseUrl = 'https://japi-pre.dailyinsight.cn'; //正式
let japibaseUrl = 'https://japi-pre.dailyinsight.cn'; //正式japibaseUrl

// let baseUrl= "http://7dbf-223-88-44-135.ngrok.io" //汇付接口测试
let baseImgPath = "";//微信二维码
let ossurl = "";//其他上传目录
let isShowPer = false
// if (process.env.NODE_ENV == 'development') {
//     baseUrl = 'http://go.confluxip.com';//测试
// } else {
//     baseUrl = 'https://api.iliyu.com.cn';// 正式
// }

localStorage.setItem("lang", "zh-cn")
let language = 'zh-cn' // 语言切换，国内写zh-cn，美国选en-us  繁体写 zh-tw

export {
  japibaseUrl,
  baseUrl,
  baseImgPath,
  ossurl,
  isShowPer,
  language
}
//



// WEBPACK FOOTER //
// ./src/common/env.js